import React from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';

import Home from './views/home.js';

import './styles/core.scss';

export default function App({store}) {
    return (
        <Provider store={store}>
            <div className="container">
                <Home />
            </div>
        </Provider>
    );
}
App.propTypes = {
    store: PropTypes.object.isRequired
};


// WEBPACK FOOTER //
// ./src/app.js